import { useState, useEffect } from "react";
import apiRequest from "../../../../../utils/ApiRequest/apiRequest.js";
import Button from "../../../../Elements/Button/Button.js";
import BillingSumSection from "./components/BillingSumSection/index.tsx";
import CreditCardModal from "./modals/CreditCardModal.tsx";
import InvoiceModal from "./modals/InvoiceModal.tsx";
import Skeleton from "react-loading-skeleton";
import StatementsPage from "./StatementsPage.js";
import { useContent } from "../../../../../contexts/contentContext/contentContext.js";
import { useModal } from "../../../../../contexts/modalContext/modalContext.js";
import { useUser } from "contexts/userContext/userContext.js";
import SubUserEmbedErrorPage from "../../JumboEmbed/SubUserEmbedErrorPage.js";
import PayPalPaymentSection from "./components/PayPalPaymentSection/index.tsx";
import { useParams } from "react-router-dom";
import Image from "components/Elements/Image/Image.tsx";

const PaymentPage = () => {
  const { lang } = useParams();
  const { setModal } = useModal();
  const { getUserBillingDetails, getUserData } = useUser();
  const billingDetails = getUserBillingDetails();
  const { getTextByKey, getPath } = useContent();
  const [isPayPal, setIsPayPal] = useState(false);
  const [paymentDetails, setPaymentDetails] = useState(null);
  const [isExpire, setIsExpire] = useState(false);

  const userData = getUserData();
  const [globalLoading, setGlobalLoading] = useState(false);
  const [displayDetails, setDisplayDetails] = useState(null);
  const [invoiceDetails, setInvoiceDetails] = useState({
    Name: "",
    CompanyId: "",
  });
  const [displayPrice, setDisplayPrice] = useState("");
  const [paymentURL, setPaymentURL] = useState(null);
  const [areStatementsExist, setAreStatementsExist] = useState(true);

  const getChangeCreditUrl = async () => {
    const body = {
      UsersId: userData.UserId,
      SubscriptionId: billingDetails.id,
      baseUrl: "https://www.jumbomail.me" + getPath(),
      Language: lang,
    };
    const response = await apiRequest(
      "Users",
      "GetChangeCreditUrl",
      body,
      "POST"
    );
    if (response.status === "success") {
      if (response.data) {
        if (response.data !== null && response.data.ChangeCreditIsIFrame) {
          setPaymentURL(response.data.ChangeCreditUrl);
        }
      }
    }
  };

  const getLastCreditCardDetails = async () => {
    setGlobalLoading(true);
    const response = await apiRequest("Users", "GetLastCreditCardDetails");
    if (response.status === "success") {
      //let ccv = PaymentSubscriptionId;
      if (response.data) {
        setPaymentDetails(response.data);
        //create date with response.data.exp_year and response.data.exp_month
        const date = new Date(
          response.data.exp_year,
          response.data.exp_month - 1
        );
        let dislpayDate = displayDate(date);
        let fourDigits = displayFourDigits(response.data.CreditCardNumber);
        let ccv = "XXX";
        setDisplayDetails({
          expireDate: dislpayDate,
          lastFourDigits: fourDigits,
          ccv: ccv,
        });
        //check if is not paypal and if the credit card is not expired, if yes - get the change credit url
        if (billingDetails.payment_gateway !== "PayPal") {
          getChangeCreditUrl();
          if (date > new Date()) {
            setIsExpire(true);
          }
        }
      }

      setGlobalLoading(false);
    } else {
      setGlobalLoading(false);
    }

    setIsPayPal(billingDetails && billingDetails.payment_gateway === "PayPal");
  };

  const displayDate = (date) => {
    let displayDate = null;
    if (date) {
      let convertedDate = new Date(date);
      displayDate =
        convertedDate.getMonth() + 1 > 9
          ? convertedDate.getMonth() + 1
          : "0" +
            (convertedDate.getMonth() + 1) +
            "/" +
            convertedDate.getFullYear();
    }
    return displayDate;
  };

  const displayFourDigits = (fourDigits) => {
    if (
      fourDigits !== null &&
      fourDigits !== "" &&
      /(?:\bdigit-|\s|^)(\d{4})(?=[.?\s]|-digit\b|$)/gi.test(fourDigits)
    ) {
      return "XXXX-XXXX-XXXX-" + fourDigits;
    } else {
      return "";
    }
  };

  // const CheckPaymentDetails = async (id) => {
  //   const parameters = {
  //     subsriptionId: id,
  //   };
  //   const response = await apiRequest(
  //     "Users",
  //     "CheckPaymentDetails",
  //     parameters
  //   );
  //   if (response.status === "success") {
  //     console.log("res -CheckPaymentDetails", response);
  //     if (response.data) {
  //     }
  //   } else {
  //   }
  // };

  // const CheckIfCreditCardExpired = async (payapl, id) => {
  //   const parameters = {
  //     subscriptionId: userData.UserSubscriptionId,
  //     subscriptionPaymentId: id,
  //     baseUrl: "https://www.jumbomail.me" + getPath(),
  //     isPaypal: payapl,
  //   };
  //   const response = await apiRequest(
  //     "Users",
  //     "CheckIfCreditCardExpired",
  //     parameters
  //   );
  //   if (response.status === "success") {
  //     console.log("res -CheckIfCreditCardExpired", response);
  //     if (response.data) {
  //       if (response.data === "true") {
  //         GetChangeCreditUrl(id);
  //       }
  //     }
  //   } else {
  //     console.log("res -CheckIfCreditCardExpired", response);
  //   }
  // };

  // const GetChangeCreditUrl = async (id) => {
  //   const body = {
  //     SubscriptionId: id,
  //     baseUrl: "https://www.jumbomail.me" + getPath(),
  //   };
  //   const response = await apiRequest(
  //     "Users",
  //     "GetChangeCreditUrl",
  //     body,
  //     "POST"
  //   );
  //   if (response.status === "success") {
  //     if (response.data) {
  //       if (response.data !== null && response.data.ChangeCreditIsIFrame) {
  //         setPaymentURL(response.data.ChangeCreditUrl);
  //         setIsExpire(false);
  //       } else if (isPayPal) {
  //         setIsExpire(true);
  //       }
  //     }
  //   }
  // };

  const GetSubscriptionStorageById = async () => {
    const parameters = {
      subscriptionStorageId: userData.UserSubscriptionId,
    };
    const response = await apiRequest(
      "Packages",
      "GetSubscriptionStorageById",
      parameters
    );
    if (response.status === "success") {
      if (response.data) {
        let price = "";
        let currency = "";
        if (userData.RenewableSubsciber) {
          price = response.data.SubscriberStorage_Monthly_Price;
        } else {
          price = response.data.SubscriberStorage_Annual_Price;
        }
        switch (response.data.SubscriberStorage_Currency) {
          case "NIS":
            currency = "₪";
            break;
          case "USD":
            currency = "$";
            break;
          case "EUR":
            currency = "€";
          default:
            break;
        }

        setDisplayPrice(price + " " + currency);
      }
    }
  };

  const GetUserByBearer = async () => {
    const response = await apiRequest("Users", "GetUserByBearer");
    if (response.status === "success") {
      if (response.data) {
        let invoiceName = response.data.User_Invoice_Name;
        let invoiceCompanyId = response.data.User_Invoice_Id;
        setInvoiceDetails({
          Name: invoiceName,
          CompanyId: invoiceCompanyId,
        });
      }
    }
  };

  useEffect(() => {
    if (userData) {
      GetSubscriptionStorageById();
      GetUserByBearer();
      if (userData.RenewableSubsciber || userData.RenewableEmbed) {
        setGlobalLoading(true);
        // GetSubscriptionPaymentDetails();
      }
      setInvoiceDetails({
        Name: userData.User_Invoice_Name,
        CompanyId: userData.User_Invoice_Id,
      });
      getLastCreditCardDetails();
    }
  }, []);

  const skeletonPaymentAndInvoice = () => {
    return (
      <div className="payment-method-details">
        <div className="payment-details">
          <div className="details-text">
            <div className="table-title">
              <Skeleton
                containerClassName=""
                width="100%"
                count={1}
                height={28}
              />
            </div>
            <div className="table-row one-field">
              <div className="text">
                <Skeleton
                  containerClassName=""
                  width="100%"
                  count={1}
                  height={16}
                />
              </div>
              <Skeleton
                containerClassName=""
                count={1}
                width="100%"
                height={44}
              />
            </div>
            <div className="table-row two-fields">
              <div className="expiration-field">
                <div className="text">
                  <Skeleton
                    containerClassName=""
                    width="100%"
                    count={1}
                    height={16}
                  />
                </div>
                <Skeleton
                  containerClassName=""
                  inline
                  count={1}
                  width={105}
                  height={44}
                />
              </div>
              <div className="cvv-field">
                <div className="text">
                  <Skeleton
                    containerClassName=""
                    width="100%"
                    count={1}
                    height={16}
                  />
                </div>
                <Skeleton
                  containerClassName=""
                  count={1}
                  width={75}
                  height={44}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="invoice-details">
          <div className="details-text">
            <div className="table-title">
              <Skeleton
                containerClassName=""
                width="100%"
                count={1}
                height={28}
              />
            </div>
            <div className="table-row one-field">
              <div className="text">
                <Skeleton
                  containerClassName=""
                  width="100%"
                  count={1}
                  height={16}
                />
              </div>
              <div className="value">
                <Skeleton
                  containerClassName=""
                  width="100%"
                  count={1}
                  height={44}
                />
              </div>
            </div>
            <div className="table-row one-field">
              <div className="text">
                <Skeleton
                  containerClassName=""
                  width="100%"
                  count={1}
                  height={16}
                />
              </div>
              <div className="value">
                <Skeleton
                  containerClassName=""
                  width="100%"
                  count={1}
                  height={44}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  if (getUserData() && getUserData().IsSubUser) {
    return <SubUserEmbedErrorPage />;
  }

  return (
    <div className="payment-container">
      <div className="title">
        <h1>{getTextByKey("payment-method-title")}</h1>
      </div>
      <div className="payment-content-container">
        {/* <BillingSumSection /> */}
        <div />
        <div>
          {!globalLoading ? (
            isPayPal ? (
              <PayPalPaymentSection />
            ) : !areStatementsExist ? (
              <div className="no-transactions">
                <Image name="inbox-empty" ext="png" />
                <h2>{getTextByKey("payment-method-statement")}</h2>
                <p>{getTextByKey("no-payment-statements")}</p>
              </div>
            ) : (
              <div
                className={`payment-method-details ${
                  paymentDetails ? "" : "false"
                }`}
              >
                {paymentDetails ? (
                  <>
                    <div className={`payment-details`}>
                      <div className="details-text">
                        <div className="table-title">
                          {getTextByKey("payment-details-title")}
                        </div>
                        <div className="table-row one-field">
                          <div className="text">
                            {getTextByKey("payment-method-credit-four")}
                          </div>
                          <input
                            value={
                              displayDetails && displayDetails.lastFourDigits
                            }
                            disabled
                          />
                        </div>
                        <div className="table-row two-fields">
                          <div className="expiration-field">
                            <div className="text">
                              {getTextByKey("payment-method-credit-date")}
                            </div>
                            <input
                              disabled
                              value={
                                displayDetails && displayDetails.expireDate
                              }
                            />
                          </div>
                          <div className="cvv-field">
                            <div className="text">
                              {getTextByKey("payment-method-credit-ccv")}
                            </div>
                            <input
                              value={displayDetails && displayDetails.ccv}
                              disabled
                            />
                          </div>
                        </div>
                      </div>
                      {paymentURL && (
                        <div
                          className={`details-button" ${
                            !isExpire ? "expire" : ""
                          } `}
                        >
                          <div className="">
                            <div className="openModal">
                              <Button
                                onClick={() =>
                                  setModal(() => (
                                    <CreditCardModal
                                      url={paymentURL}
                                      getLastCreditCardDetails={
                                        getLastCreditCardDetails
                                      }
                                    />
                                  ))
                                }
                              >
                                {getTextByKey("payment-method-change-btn")}
                              </Button>
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                    <div className="invoice-details">
                      <div className="details-text">
                        <div className="table-title">
                          {getTextByKey("payment-invoice-details")}
                        </div>
                        <div className="table-row one-field">
                          <div className="text">
                            {getTextByKey("payment-invoice-company-id")}
                          </div>
                          <div className="value">
                            {" "}
                            <input
                              id="invoiceIdDisabled"
                              type="text"
                              value={invoiceDetails.CompanyId}
                              disabled="disabled"
                            />
                          </div>
                        </div>
                        <div className="table-row one-field">
                          <div className="text">
                            {getTextByKey("payment-invoice-name")}
                          </div>
                          <div className="value">
                            {" "}
                            <input
                              id="invoiceNameDisabled"
                              type="text"
                              value={invoiceDetails.Name}
                              disabled="disabled"
                            />
                          </div>
                        </div>
                      </div>
                      <div className="details-button">
                        <div className="year_currenDir">
                          <Button
                            onClick={() =>
                              setModal(() => (
                                <InvoiceModal
                                  UserId={userData && userData.UserId}
                                  UserInvoiceId={invoiceDetails.CompanyId}
                                  UserInvoiceName={invoiceDetails.Name}
                                  setInvoiceDetails={setInvoiceDetails}
                                />
                              ))
                            }
                          >
                            {getTextByKey("payment-invoice-change-title")}
                          </Button>
                        </div>
                      </div>
                    </div>
                  </>
                ) : (
                  <div>
                    <div className="table-title">
                      {getTextByKey("payment-details-title")}
                    </div>
                    <div className="payment-does-not-exist">
                      {getTextByKey("no-payment-methods")}
                    </div>
                  </div>
                )}
              </div>
            )
          ) : (
            skeletonPaymentAndInvoice()
          )}
          <StatementsPage
            userData={userData}
            setAreStatementsExist={setAreStatementsExist}
          />
        </div>
      </div>
    </div>
  );
};

export default PaymentPage;
